import React, { useState, useCallback } from "react"

import { ReactComponent as BellSvg } from 'resources/icons/bells/bell_ring_solid.svg'
import { ReactComponent as BlinkSvg } from 'resources/icons/general/blink_solid.svg'
import { ReactComponent as TemplateSvg } from 'resources/icons/general/template_solid.svg'
import { ReactComponent as DynamicDateSvg } from 'resources/icons/date/dynamic_solid.svg'
import { ReactComponent as MailSvg } from 'resources/icons/general/mail_send_solid.svg'

import * as st from './Automation.styled.js'

const items = [
  {
    id: "templates",
    name: "Powerful templates",
    description: "Project templates with team and customer roles, relative task start and due dates, shared resources, welcome kit, and other. Start fully configured new onboarding project in a few clicks or automatically.",
    image: {
      src: "//cdn-platform.scope-dev.ws/website/images/screens/index/automation/templates.webp",
      src2x: "//cdn-platform.scope-dev.ws/website/images/screens/index/automation/templates@2x.webp",
      width: 760,
      height: 560,
    },
    Icon: TemplateSvg,
  },
  {
    id: "ai-reminders",
    name: "AI-driven reminders",
    description: "AI automatically recognizes questions in communication and marks tasks as \"Waiting for response\". It allows to configure different reminder flows for informational and questionable messages.",
    image: {
      src: "//cdn-platform.scope-dev.ws/website/images/screens/index/automation/ai-notification.webp",
      src2x: "//cdn-platform.scope-dev.ws/website/images/screens/index/automation/ai-notification@2x.webp",
      width: 760,
      height: 560,
    },
    Icon: BellSvg,
  },
  {
    id: "ai-autofill",
    name: "AI autofill",
    description: "Use AI to autofill any task fields based on task activity, communication, and properties. With customizable prompts, you can create any rules to automatically update task properties and generate reports based on them.",
    image: {
      src: "//cdn-platform.scope-dev.ws/website/images/screens/index/automation/ai-autofill.webp",
      src2x: "//cdn-platform.scope-dev.ws/website/images/screens/index/automation/ai-autofill@2x.webp",
      width: 760,
      height: 560,
    },
    Icon: BlinkSvg,
  },
  {
    id: "dynamic-dates",
    name: "Dynamic onboarding plan",
    description: "Automatically adjust task start and due dates based on completion of current tasks. This helps get rid of unnecessary delays between tasks in onboarding plan and ensures automatic notifications for the next steps.",
    image: {
      src: "//cdn-platform.scope-dev.ws/website/images/screens/index/automation/dynamic-dates.webp",
      src2x: "//cdn-platform.scope-dev.ws/website/images/screens/index/automation/dynamic-dates@2x.webp",
      width: 760,
      height: 560,
    },
    Icon: DynamicDateSvg,
  },
  {
    id: "scheduled-emails",
    name: "Scheduled emails",
    description: "Schedule emails to be sent automatically on specific project days or triggered by events such as “Task Start”, “Task Completed”, “Stage Completed”, and others.",
    image: {
      src: "//cdn-platform.scope-dev.ws/website/images/screens/index/automation/emails.webp",
      src2x: "//cdn-platform.scope-dev.ws/website/images/screens/index/automation/emails@2x.webp",
      width: 760,
      height: 560,
    },
    Icon: MailSvg,
  },
];

const Automation = () => {
  const [activeId, setActiveId] = useState("templates");

  const activeItem = items.find(({ id }) => id === activeId) || {};

  const onOpenMenu = useCallback((id, event) => {
    setActiveId(id);
    if (window.innerWidth <= 768) {
      setTimeout(() => {
        const element = event.target;
        const rect = element.getBoundingClientRect();
        const offsetTop = rect.top + window.pageYOffset - 80;

        window.scrollTo({
          top: offsetTop,
          behavior: 'smooth',
        });
      }, 350);
    }
  }, [])

  return (
    <st.Wrap
      color="indigo"
      Icon={BlinkSvg}
      isTopLine
    >
      <st.Content>
        <st.TitleWrap>
          <st.Title>
            <ins>Automate</ins> customer onboarding with&nbsp;<ins>AI</ins>
          </st.Title>
        </st.TitleWrap>
        <st.FeaturesWrap>
          <st.List>
            {items.map(({ id, name, description, image, Icon }) => (
              <st.Item
                key={id}
                isActive={activeId === id}
              >
                <st.ItemContent>
                  <st.ItemButton
                    isActive={activeId === id}
                    onClick={event => onOpenMenu(id, event)}
                  >
                    <Icon />
                    {name}
                  </st.ItemButton>
                  <st.ItemText>{description}</st.ItemText>
                  <st.ItemImageWrap>
                    <img
                      src={image.src}
                      srcSet={`${image.src} 1x, ${image.src2x} 2x`}
                      width={image.width}
                      height={image.height}
                      alt={name}
                    />
                  </st.ItemImageWrap>
                </st.ItemContent>
              </st.Item>
            ))}
          </st.List>
          <st.ImageWrap>
            <img
              key={activeItem.id}
              src={activeItem.image?.src}
              srcSet={`${activeItem.image?.src} 1x, ${activeItem.image?.src2x} 2x`}
              width={activeItem.image?.width}
              height={activeItem.image?.height}
              alt={activeItem.name}
            />
          </st.ImageWrap>
        </st.FeaturesWrap>
      </st.Content>
    </st.Wrap>
  )
}

export default Automation
